import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {GoogleMap, InfoWindow, LoadScript, Marker, Polygon, useLoadScript} from "@react-google-maps/api";
import MapElements from "./MapElements";
import MarkerPopup from "./MarkerPopup";
import { getEnv } from "../../../../lib/env";
export default function Map({stations, center, isfilter,z}) {
    const {isLoaded} = useLoadScript({
        googleMapsApiKey: getEnv('REACT_APP_API_KEY')
    });

    if (!isLoaded) return <div>Loading . . .</div>
    return (
        <Mapping stations={stations} c={center} isfilter={isfilter} z={z}/>
    );
}
function Mapping({stations,c,isfilter,z}){
    const [zoom, setZoom] = useState(11)
    const [center, setCenter] = useState({ lat: 41.5636681, lng: 62.695678 });
    const newCenter = useSelector(state=>state.map)
    const [selected,setSelected]=useState(null)
    const [map,setMap] = useState(null)
    useEffect(() => {
        if(newCenter){
            setCenter(newCenter.defaultCenter)
            setZoom(newCenter.defaultZoom)
        }
    },[newCenter]);
    useEffect(() => {
        if(c && c.lat && c.lng){
            setCenter(c)
            setZoom(z)
            if(map){
                map.panTo(c)
                map.zoom = z
            }

        }
    },[c]);
    useEffect(() => {
        setSelected(null)
    },[isfilter]);
    return (
        <GoogleMap
            mapContainerClassName="MapContainer"
            zoom={zoom}
            center={center}
            mapTypeId = 'satellite'
            onLoad={map=> setMap(map)}
        >
            {selected?
                <InfoWindow
                    position={
                        {
                            lat:parseFloat(selected.lat),
                            lng:parseFloat(selected.lan)
                        }
                    }
                    onCloseClick={()=>setSelected(null)}
                >
                    <MarkerPopup st={selected} />
                </InfoWindow>
                :null}
            {
                stations.length>0?
                    <MapElements setSelected={setSelected} stations={stations}/>
                    :null}
        </GoogleMap>
    );
}
